import React from "react";
import noImage from "../../../../../../assets/images/noImage.png";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import { IconButton } from "@mui/material";
import { IoInformationCircleOutline } from "react-icons/io5";

export default function ShopifyProducts(props) {
  const { shopifyProducts } = props;
  return (
    <div className="card bg-ui-surface shadow wapper_like_shopify">
      <div className="card-header package__dimension_header_wrap">
        <div className="package__dimension_header_content">
          <span>Synced Products</span>
          <Tooltip title="Shopify Order Product Summary">
            <IconButton>
              <IoInformationCircleOutline size={15} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div className="card-body dimension_weight_card_body">
        <div className="overflow-x-auto">
          <div className="min-w-[800px] w-full mx-auto">
            {/* Header Row */}
            <div className="flex text-sm font-medium py-2">
              <div className="flex-1 text-center">Products</div>
              <div className="flex-1 text-center">Name</div>
              <div className="flex-1 text-center">SKU</div>
              <div className="flex-1 text-center">Size (L×W×H)</div>
              <div className="flex-1 text-center">Weight</div>
              <div className="flex-1 text-center">Quantity</div>
              <div className="flex-1 text-center">Item Value</div>
            </div>

            {/* Product Rows */}
            {shopifyProducts?.map((singlelist, index) => (
              <div key={index} className="flex items-center text-sm py-2">
                <div className="flex-1 flex items-center justify-center gap-2">
                  <span>#{index + 1}</span>
                  <img
                    src={singlelist?.shopify_image ?? noImage}
                    onError={(e) => {
                      e.target.src = noImage;
                    }}
                    className="w-10 h-10 rounded object-contain"
                    alt="Product"
                  />
                </div>
                <div className="flex-1 text-center">
                  {singlelist?.product_name}
                </div>
                <div className="flex-1 text-center">{singlelist.sku}</div>
                <div className="flex-1 text-center">
                  {singlelist?.length ?? "0"}×{singlelist?.width ?? "0"}×
                  {singlelist?.height ?? "0"} {singlelist?.dimension_unit}
                </div>
                <div className="flex-1 text-center">
                  {singlelist?.weight ?? "0"} {singlelist?.weight_unit}
                </div>
                <div className="flex-1 text-center">
                  {singlelist?.item_quantity ?? "0"}
                </div>
                <div className="flex-1 text-center">
                  {singlelist?.item_total ?? "0"}$
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
